var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "maren-sol" },
        [
          _c("el-container", { staticClass: "d-flex-column" }, [
            _c("h1", [_vm._v("Contact us")]),
            _c("p", [
              _vm._v("We have our presence across the globe and a"),
              _c("span", { staticClass: "d-block" }, [
                _vm._v("dedicated development center in India which provides")
              ]),
              _vm._v(" platform to create multiple products with "),
              _c("span", { staticClass: "d-block" }, [
                _vm._v("vast experience into different technologies,")
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "el-container",
        { staticClass: "d-flex-column p-tb50" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c("el-col", { staticClass: "p-t130", attrs: { span: 10 } }, [
                _c("div", { staticClass: "location" }, [
                  _c("h3", [
                    _c("i", { staticClass: "icon-location4 navyblue-text" }),
                    _vm._v("India")
                  ]),
                  _c("strong", [_vm._v("Maren solutions Pvt Ltd")]),
                  _vm._v("\n            PSR Prime Towers, B-Block "),
                  _c("span", { staticClass: "d-block" }, [
                    _vm._v("2nd floor, Beside DLF Gate No: 1, ")
                  ]),
                  _vm._v(" Gachibowli, Hyderabad 500032 \n          ")
                ]),
                _c("div", { staticClass: "location" }, [
                  _c("h3", [
                    _c("i", { staticClass: "icon-location4 pink-text" }),
                    _vm._v("Saudi Arabia")
                  ]),
                  _c("strong", [_vm._v("Sanar Ecommerce Company LLC")]),
                  _vm._v("\n            Post Box 1900,Khamis Musha"),
                  _c("span", { staticClass: "d-block" }, [
                    _vm._v("Asser,Saudi Arabia-61961 ")
                  ])
                ])
              ]),
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c("h2", [_vm._v("Contact us")]),
                  _c(
                    "el-card",
                    { staticClass: "form-bg", attrs: { shadow: "never" } },
                    [
                      _c("img", {
                        staticClass: "triangel",
                        attrs: {
                          src: require("../../../public/img/contactus/triangel.svg"),
                          alt: "Triangel"
                        }
                      }),
                      _c("img", {
                        staticClass: "oval",
                        attrs: {
                          src: require("../../../public/img/contactus/oval.svg"),
                          alt: "Oval"
                        }
                      }),
                      _c(
                        "el-form",
                        { attrs: { model: _vm.form } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 30 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Name" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.name,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "name", $$v)
                                          },
                                          expression: "form.name"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Company" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.company,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "company", $$v)
                                          },
                                          expression: "form.company"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Phone Number" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.number,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "number", $$v)
                                          },
                                          expression: "form.number"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Email" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.form.email,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "email", $$v)
                                          },
                                          expression: "form.email"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Comments" } },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "textarea", rows: 8 },
                                        model: {
                                          value: _vm.form.comment,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "comment", $$v)
                                          },
                                          expression: "form.comment"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticClass: "text-center",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        round: "",
                                        size: "large"
                                      },
                                      on: { click: _vm.onSubmit }
                                    },
                                    [_vm._v("Submit")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/views/static/Contactus.vue?vue&type=template&id=770fe1d7&
// module id = 558
// module chunks = 5